
export function debounce(fn, delay) {
    let timeout
    return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            fn(...args)
        }, delay)
    }
}

export function formatDate(date) {
    return date.toISOString().split('T')[0]
}

export function formatDateTimeShort(input) {
    const date = new Date(input.replace(" ", "T")) 
    return new Intl.DateTimeFormat(undefined, {
        dateStyle: "short", 
        timeStyle: "short", 
        hour12: false       
    }).format(date)
}

export function formatDateTimeText(input) {
    const date = new Date(input.replace(" ", "T"))
    const datePart = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    })
    const timePart = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    })
    return `${datePart} at ${timePart}`
}

export function formatCurrency(amount, currency) {
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount)
}

export function createScript(src, async = false) {
    const script = document.createElement('script')
    script.src = src
    if (async) {
        script.async = true
    }
    document.body.appendChild(script)
    return script
}

export function getBacktestProcessingStatus(processing) {
    let processingStatus = ''
    if (processing == 100) {
        processingStatus = 'completed'
    } else if (processing == 200) {
        processingStatus = 'error'
    } else {
        processingStatus = 'processing'
    }
    return processingStatus
}

export function getSymbolCurrency(symbol) {
    switch (symbol) {
        case 'USD':
            return '$'
        case 'EUR':
            return '€'
        case 'GBP':
            return '£'
        default:
            return symbol
    }
}